import React from 'react';
import { ComponentInfo, MembershipCompletionEnterpriseSolution } from '@components';

export const MembershipCompletionEnterpriseSolutionPlaceholder: React.FC = () => {
	return (
		<ComponentInfo name="MembershipCompletionEnterpriseSolutionPlaceholder">
			<MembershipCompletionEnterpriseSolution />
		</ComponentInfo>
	);
};
